<template>
  <div id="headerBackground" :class="{ mobile: mobileView }"></div>
</template>

<script>
export default {
  name: "headerBackground",
  computed: {
    mobileView: function() {
      return window.matchMedia("(max-width: 1199px)").matches;
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  height: 85px;
  width: 100%;
  background-color: #1c79be;
  &.mobile {
    height: 60px;
  }
}
</style>
